module.exports = __webpack_public_path__ + "static/media/po-KDPF-Filter.10166085.png";